import { timezones } from './timezones.js';

var useTimezone = function () {
    return timezones;
};

export { useTimezone };
//# sourceMappingURL=useTimezone.js.map
